import React from 'react';
import { deviceCheckHtml } from './deviceCheckHtml';
export default function DeviceCheck() {
  return <iframe title="Teste de câmera e microfone" srcDoc={deviceCheckHtml} allow="camera; microphone; autoplay" style={{ width:'100%', height:'65vh', border:0 }} />;
}
